// src/features/collaboration/services/inviteEmailService.js
import { httpsCallable } from "firebase/functions";
import { functions } from "../../../firebase/config";

export const sendInviteEmail = async (payload) => {
  const callable = httpsCallable(functions, "sendInviteEmail");
  const result = await callable(payload);
  return result?.data;
};
